import { ReactElement, useEffect, useState } from 'react';
import classNames from 'classnames';

const TIPS = [
  'Your knowledge base only answers from the sources you connect — every answer includes citations, so you can trace exactly where it came from.',
  'Mix sources freely: one knowledge base can combine Google Drive documents, Notion pages, website URLs, and uploaded files.',
  'Enable the "Ready to query" notification under Settings → Notifications to be told the moment your knowledge base finishes processing.',
  'Brand themes are reusable — set up your logo, colours, and chat title once and apply them to any number of knowledge bases.',
  'Serve your knowledge base on your own domain — add it on the Domains screen, then attach it in your knowledge base’s settings.',
  'Restrict access with visibility rules: allow specific emails or a whole email domain, and visitors sign in with a magic link — no passwords needed.',
  'Signed-in visitors on restricted knowledge bases get saved chat history and bookmarks.',
  'Every plan includes unlimited users at no extra cost — share your knowledge base with 5 people or 500 for the same price.',
  'Sources don’t re-sync automatically — when a document changes, re-import it to update your knowledge base.',
  'Rate limits are your cost control: cap questions per visitor per hour so a burst of traffic can’t run through your monthly allowance.',
  'Need deeper answers? Raise the query depth multiplier in your knowledge base’s rate limits so each answer can draw on more of your content.',
  'Adding or changing sources returns a knowledge base to draft — publish it again once processing reaches 100%.',
  'Run separate knowledge bases per team or topic — paid plans include unlimited knowledge bases, each with its own sources, branding, and access rules.',
  'Google Drive access is limited to the files you pick — Stark Chat cannot see the rest of your Drive.',
  'Upload up to 500 files at a time — PDF, Word, Excel, and plain text are all supported.',
];

const TIP_INTERVAL_MS = 8000;

const FADE_MS = 300;

export const ProcessingTip = (): ReactElement => {
  const [tipIndex, setTipIndex] = useState(0);

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let fade: ReturnType<typeof setTimeout>;

    const interval = setInterval(() => {
      setVisible(false);

      fade = setTimeout(() => {
        setTipIndex((i) => (i + 1) % TIPS.length);

        setVisible(true);
      }, FADE_MS);
    }, TIP_INTERVAL_MS);

    return () => {
      clearInterval(interval);

      clearTimeout(fade);
    };
  }, []);

  return (
    <p
      className={classNames(
        'mt-5 text-sm text-text-low-priority transition-opacity duration-300',
        visible ? 'opacity-100' : 'opacity-0'
      )}
    >
      <span className="font-semibold text-white">Tip: </span>
      {TIPS[tipIndex]}
    </p>
  );
};
